/* @flow */

import classNames from 'classnames';
import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import { getUserInitials } from '@braindate/domain/lib/user/util';

import styles from './DefaultUserAvatar.style';

import type { User } from '@braindate/domain/lib/user/type';
import type { AvatarProps } from 'src/shared/ui/component/image/type/avatarTypes';

type Props = AvatarProps & {
  user: User,
};

const useStyles = createUseThemeStyles(styles);

const DefaultUserAvatar = ({
  layoutClass,
  variant,
  user,
  alt,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles({ variant });

  const rootClasses = classNames(classes.root, layoutClass);

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <div className={rootClasses} aria-label={alt} aria-hidden={!alt}>
      {getUserInitials(user)}
    </div>
  );
};

// Make variants available
export * from 'src/shared/ui/component/image/setting/avatarVariants';

export default React.memo<Props>(DefaultUserAvatar);
